module.exports = __webpack_public_path__ + "static/img/Inspection33.c166bf04.png";